@for (group of groups; track group) {
  @for (item of group.items; track item) {
    <ng-container class="items">
      <div [ngClass]="{ item: true, 'has-children': !!item.children?.length }" routerLinkActive="active">
        @if (item.children?.length) {
          <button class="open-button" (click)="toggleSubitems($event)">
            <mat-icon>chevron_right</mat-icon>
          </button>
        }
        @if (!item.external) {
          <a [routerLink]="item.link" [matTooltip]="item.text | translate" matTooltipPosition="after">
            <mat-icon class="material-icons-outlined">{{ item.icon }}</mat-icon>
            <span class="text">{{ item.text | translate }}</span>
            <span class="count">{{ item.count > 99 ? '99+' : item.count }}</span>
          </a>
        }
        @if (item.external) {
          <a [href]="item.link" [matTooltip]="item.text | translate" matTooltipPosition="after">
            <mat-icon class="material-icons-outlined">{{ item.icon }}</mat-icon>
            <span class="text">{{ item.text | translate }}</span>
            <span class="count">{{ item.count > 99 ? '99+' : item.count }}</span>
          </a>
        }
      </div>
      <div class="items">
        @for (item of item.children; track item) {
          <div [ngClass]="{ item: true, 'subitem-1': true, 'has-children': !!item.children?.length }" routerLinkActive="active">
            @if (item.children?.length) {
              <button class="open-button" (click)="toggleSubitems($event)">
                <mat-icon>chevron_right</mat-icon>
              </button>
            }
            @if (!item.external) {
              <a [routerLink]="item.link" [matTooltip]="item.text | translate" matTooltipPosition="after">
                <span class="text">{{ item.text | translate }}</span>
                <span class="count">{{ item.count > 99 ? '99+' : item.count }}</span>
              </a>
            }
            @if (item.external) {
              <a [href]="item.link" [matTooltip]="item.text | translate" matTooltipPosition="after">
                <span class="text">{{ item.text | translate }}</span>
                <span class="count">{{ item.count > 99 ? '99+' : item.count }}</span>
              </a>
            }
          </div>
          <div class="items">
            @for (item of item.children; track item) {
              <div class="item subitem-2" routerLinkActive="active">
                @if (!item.external) {
                  <a [routerLink]="item.link" [matTooltip]="item.text | translate" matTooltipPosition="after">
                    <span class="text">{{ item.text | translate }}</span>
                    <span class="count">{{ item.count > 99 ? '99+' : item.count }}</span>
                  </a>
                }
                @if (item.external) {
                  <a [href]="item.link" [matTooltip]="item.text | translate" matTooltipPosition="after">
                    <span class="text">{{ item.text | translate }}</span>
                    <span class="count">{{ item.count > 99 ? '99+' : item.count }}</span>
                  </a>
                }
              </div>
            }
          </div>
        }
      </div>
    </ng-container>
  }
}
